module.exports = ".fylker-overview{background:#f4f0ee;padding:60px 20px 40px}.fylker-overview .flex-container{display:block;text-align:center}.fylker-overview .flex-container .flex-box{text-align:left;display:inline-block;width:33%;min-width:300px;max-width:380px;padding:20px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/+app/+fylker/overview/styles.scss
// module id = 787
// module chunks = 1